import i18n from '@/helpers/i18n';

export const CONSTANTS = {
    supportedLanguages: [ {"key": "en", "label": i18n.t('english')}, {"key": "pt", "label": i18n.t('portuguese')}, {"key": "es", "label": i18n.t('spanish')} ]
};
